// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
export var Np = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};
export const Se = (u, o, m, r) => {
  const g = React.forwardRef(({
    color: j = "currentColor",
    size: B = 24,
    stroke: U = 2,
    title: N,
    className: y,
    children: X,
    ...M
  }, R) => React.createElement("svg", {
    ref: R,
    ...Np[u],
    width: B,
    height: B,
    className: ["tabler-icon", `tabler-icon-${o}`, y].join(" "),
    ...(u === "filled" ? {
      fill: j
    } : {
      strokeWidth: U,
      stroke: j
    }),
    ...M
  }, [N && React.createElement("title", {
    key: "svg-title"
  }, N), ...r.map(([H, Y]) => React.createElement(H, Y)), ...(Array.isArray(X) ? X : [X])]));
  return g.displayName = `${m}`, g;
};
export const Tp = [["path", {
  d: "M5 12l14 0",
  key: "svg-0"
}], ["path", {
  d: "M5 12l6 6",
  key: "svg-1"
}], ["path", {
  d: "M5 12l6 -6",
  key: "svg-2"
}]];
export const IconArrowLeft = Se("outline", "arrow-left", "ArrowLeft", Tp);
export const Mp = [["path", {
  d: "M5 12l14 0",
  key: "svg-0"
}], ["path", {
  d: "M13 18l6 -6",
  key: "svg-1"
}], ["path", {
  d: "M13 6l6 6",
  key: "svg-2"
}]];
export const IconArrowRight = Se("outline", "arrow-right", "ArrowRight", Mp);
export const Ap = [["path", {
  d: "M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11",
  key: "svg-0"
}]];
export const IconBolt = Se("outline", "bolt", "Bolt", Ap);
export const Ep = [["path", {
  d: "M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5",
  key: "svg-0"
}], ["path", {
  d: "M12 12l8 -4.5",
  key: "svg-1"
}], ["path", {
  d: "M12 12l0 9",
  key: "svg-2"
}], ["path", {
  d: "M12 12l-8 -4.5",
  key: "svg-3"
}]];
export const IconBox = Se("outline", "box", "Box", Ep);
export const Dp = [["path", {
  d: "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12",
  key: "svg-0"
}], ["path", {
  d: "M16 3v4",
  key: "svg-1"
}], ["path", {
  d: "M8 3v4",
  key: "svg-2"
}], ["path", {
  d: "M4 11h16",
  key: "svg-3"
}], ["path", {
  d: "M11 15h1",
  key: "svg-4"
}], ["path", {
  d: "M12 15v3",
  key: "svg-5"
}]];
export const IconCalendar = Se("outline", "calendar", "Calendar", Dp);
export const zp = [["path", {
  d: "M3.604 7.197l7.138 -3.109a.96 .96 0 0 1 1.27 .527l4.924 11.902a1 1 0 0 1 -.514 1.304l-7.137 3.109a.96 .96 0 0 1 -1.271 -.527l-4.924 -11.903a1 1 0 0 1 .514 -1.304l0 .001",
  key: "svg-0"
}], ["path", {
  d: "M15 4h1a1 1 0 0 1 1 1v3.5",
  key: "svg-1"
}], ["path", {
  d: "M20 6c.264 .112 .52 .217 .768 .315a1 1 0 0 1 .53 1.311l-2.298 5.374",
  key: "svg-2"
}]];
export const IconCards = Se("outline", "cards", "Cards", zp);
export const Op = [["path", {
  d: "M3 13a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -6",
  key: "svg-0"
}], ["path", {
  d: "M15 9a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -10",
  key: "svg-1"
}], ["path", {
  d: "M9 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1l0 -14",
  key: "svg-2"
}], ["path", {
  d: "M4 20h14",
  key: "svg-3"
}]];
export const IconChartBar = Se("outline", "chart-bar", "ChartBar", Op);
export const Rp = [["path", {
  d: "M5 12l5 5l10 -10",
  key: "svg-0"
}]];
export const IconCheck = Se("outline", "check", "Check", Rp);
export const Bp = [["path", {
  d: "M6 9l6 6l6 -6",
  key: "svg-0"
}]];
export const IconChevronDown = Se("outline", "chevron-down", "ChevronDown", Bp);
export const Up = [["path", {
  d: "M15 6l-6 6l6 6",
  key: "svg-0"
}]];
export const IconChevronLeft = Se("outline", "chevron-left", "ChevronLeft", Up);
export const Hp = [["path", {
  d: "M9 6l6 6l-6 6",
  key: "svg-0"
}]];
export const IconChevronRight = Se("outline", "chevron-right", "ChevronRight", Hp);
export const Lp = [["path", {
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
  key: "svg-0"
}], ["path", {
  d: "M10 10l4 4m0 -4l-4 4",
  key: "svg-1"
}]];
export const IconCircleX = Se("outline", "circle-x", "CircleX", Lp);
export const Gp = [["path", {
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0",
  key: "svg-0"
}], ["path", {
  d: "M12 7v5l3 3",
  key: "svg-1"
}]];
export const IconClock = Se("outline", "clock", "Clock", Gp);
export const Yp = [["path", {
  d: "M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0",
  key: "svg-0"
}], ["path", {
  d: "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1",
  key: "svg-1"
}], ["path", {
  d: "M12 7v10",
  key: "svg-2"
}]];
export const IconCoin = Se("outline", "coin", "Coin", Yp);
export const Xp = [["path", {
  d: "M3 8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -8",
  key: "svg-0"
}], ["path", {
  d: "M3 10l18 0",
  key: "svg-1"
}], ["path", {
  d: "M7 15l.01 0",
  key: "svg-2"
}], ["path", {
  d: "M11 15l2 0",
  key: "svg-3"
}]];
export const IconCreditCard = Se("outline", "credit-card", "CreditCard", Xp);
export const Zp = [["path", {
  d: "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4l4 -6",
  key: "svg-0"
}]];
export const IconCrown = Se("outline", "crown", "Crown", Zp);
export const Vp = [["path", {
  d: "M6 5h12l3 5l-8.5 9.5a.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5",
  key: "svg-0"
}], ["path", {
  d: "M10 12l-2 -2.2l.6 -1",
  key: "svg-1"
}]];
export const IconDiamond = Se("outline", "diamond", "Diamond", Vp);
export const $p = [["path", {
  d: "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
  key: "svg-0"
}], ["path", {
  d: "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6",
  key: "svg-1"
}]];
export const IconEye = Se("outline", "eye", "Eye", $p);
export const Jp = [["path", {
  d: "M12 10.941c2.333 -3.308 .167 -7.823 -1 -8.941c0 3.395 -2.235 5.299 -3.667 6.706c-1.43 1.408 -2.333 3.294 -2.333 5.588c0 3.704 3.134 6.706 7 6.706c3.866 0 7 -3.002 7 -6.706c0 -1.712 -1.232 -4.403 -2.333 -5.588c-2.084 3.353 -3.257 3.353 -4.667 2.235",
  key: "svg-0"
}]];
export const IconFlame = Se("outline", "flame", "Flame", Jp);
export const Wp = [["path", {
  d: "M3 9a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1l0 -2",
  key: "svg-0"
}], ["path", {
  d: "M12 8l0 13",
  key: "svg-1"
}], ["path", {
  d: "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7",
  key: "svg-2"
}], ["path", {
  d: "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5",
  key: "svg-3"
}]];
export const IconGift = Se("outline", "gift", "Gift", Wp);
export const Fp = [["path", {
  d: "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572",
  key: "svg-0"
}]];
export const IconHeart = Se("outline", "heart", "Heart", Fp);
export const ev = [["path", {
  d: "M12 8l0 4l2 2",
  key: "svg-0"
}], ["path", {
  d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5",
  key: "svg-1"
}]];
export const IconHistory = Se("outline", "history", "History", ev);
export const av = [["path", {
  d: "M9 15l6 -6",
  key: "svg-0"
}], ["path", {
  d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464",
  key: "svg-1"
}], ["path", {
  d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463",
  key: "svg-2"
}]];
export const IconLink = Se("outline", "link", "Link", av);
export const nv = [["path", {
  d: "M12 4v3m-4 -3v6m8 -6v6",
  key: "svg-0"
}], ["path", {
  d: "M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5l-3 -1.5",
  key: "svg-1"
}]];
export const IconMedal = Se("outline", "medal", "Medal", nv);
export const sv = [["path", {
  d: "M6 6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -12",
  key: "svg-0"
}], ["path", {
  d: "M14 6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1l0 -12",
  key: "svg-1"
}]];
export const IconPlayerPause = Se("outline", "player-pause", "PlayerPause", sv);
export const cv = [["path", {
  d: "M7 4v16l13 -8l-13 -8",
  key: "svg-0"
}]];
export const IconPlayerPlay = Se("outline", "player-play", "PlayerPlay", cv);
export const uv = [["path", {
  d: "M12 5l0 14",
  key: "svg-0"
}], ["path", {
  d: "M5 12l14 0",
  key: "svg-1"
}]];
export const IconPlus = Se("outline", "plus", "Plus", uv);
export const ov = [["path", {
  d: "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4",
  key: "svg-0"
}], ["path", {
  d: "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4",
  key: "svg-1"
}]];
export const IconRefresh = Se("outline", "refresh", "Refresh", ov);
export const rv = [["path", {
  d: "M10.586 10.586l-1.586 -1.586",
  key: "svg-0"
}], ["path", {
  d: "M13.414 10.586l1.586 -1.586",
  key: "svg-1"
}], ["path", {
  d: "M13.414 13.414l1.586 1.586",
  key: "svg-2"
}], ["path", {
  d: "M10.586 13.414l-1.586 1.586",
  key: "svg-3"
}], ["path", {
  d: "M14 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0",
  key: "svg-4"
}], ["path", {
  d: "M16.5 4.206l-.5 .866",
  key: "svg-5"
}], ["path", {
  d: "M7.5 19.794l.5 -.866",
  key: "svg-6"
}], ["path", {
  d: "M19.794 7.5l-.866 .5",
  key: "svg-7"
}], ["path", {
  d: "M4.206 16.5l.866 -.5",
  key: "svg-8"
}], ["path", {
  d: "M7.5 4.206l.5 .866",
  key: "svg-9"
}], ["path", {
  d: "M16.5 19.794l-.5 -.866",
  key: "svg-10"
}], ["path", {
  d: "M4.206 7.5l.866 .5",
  key: "svg-11"
}], ["path", {
  d: "M19.794 16.5l-.866 -.5",
  key: "svg-12"
}], ["path", {
  d: "M12 3v1",
  key: "svg-13"
}], ["path", {
  d: "M12 21v-1",
  key: "svg-14"
}], ["path", {
  d: "M21 12h-1",
  key: "svg-15"
}], ["path", {
  d: "M3 12h1",
  key: "svg-16"
}], ["path", {
  d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18",
  key: "svg-17"
}]];
export const IconRoulette = Se("outline", "roulette", "Roulette", rv);
export const fv = [["path", {
  d: "M3 10a7 7 0 1 0 14 0a7 7 0 1 0 -14 0",
  key: "svg-0"
}], ["path", {
  d: "M21 21l-6 -6",
  key: "svg-1"
}]];
export const IconSearch = Se("outline", "search", "Search", fv);
export const hv = [["path", {
  d: "M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06",
  key: "svg-0"
}], ["path", {
  d: "M15 19l2 2l4 -4",
  key: "svg-1"
}]];
export const IconShieldCheck = Se("outline", "shield-check", "ShieldCheck", hv);
export const pv = [["path", {
  d: "M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2m0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2m-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6",
  key: "svg-0"
}]];
export const IconSparkles = Se("outline", "sparkles", "Sparkles", pv);
export const vv = [["path", {
  d: "M18 8a3 3 0 0 1 0 6",
  key: "svg-0"
}], ["path", {
  d: "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5",
  key: "svg-1"
}], ["path", {
  d: "M12 8l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8",
  key: "svg-2"
}]];
export const IconSpeakerphone = Se("outline", "speakerphone", "Speakerphone", vv);
export const gv = [["path", {
  d: "M10 12.057a1.9 1.9 0 0 0 .614 .743c1.06 .713 2.472 .112 3.043 -.919c.839 -1.513 -.022 -3.368 -1.525 -4.08c-2 -.95 -4.371 .154 -5.24 2.086c-1.095 2.432 .29 5.248 2.71 6.246c2.931 1.208 6.283 -.418 7.438 -3.255c1.36 -3.343 -.557 -7.134 -3.896 -8.41c-3.855 -1.474 -8.2 .68 -9.636 4.422c-1.63 4.253 .823 9.024 5.082 10.576c4.778 1.74 10.118 -.941 11.833 -5.59a9.354 9.354 0 0 0 .577 -2.813",
  key: "svg-0"
}]];
export const IconSpiral = Se("outline", "spiral", "Spiral", gv);
export const yv = [["path", {
  d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873l-6.158 -3.245",
  key: "svg-0"
}]];
export const IconStar = Se("outline", "star", "Star", yv);
export const jv = [["path", {
  d: "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9l5 0",
  key: "svg-0"
}], ["path", {
  d: "M6.5 11.5l6 6",
  key: "svg-1"
}]];
export const IconSword = Se("outline", "sword", "Sword", jv);
export const xv = [["path", {
  d: "M21 3v5l-11 9l-4 4l-3 -3l4 -4l9 -11l5 0",
  key: "svg-0"
}], ["path", {
  d: "M5 13l6 6",
  key: "svg-1"
}], ["path", {
  d: "M14.32 17.32l3.68 3.68l3 -3l-3.365 -3.365",
  key: "svg-2"
}], ["path", {
  d: "M10 5.5l-2 -2.5h-5v5l3 2.5",
  key: "svg-3"
}]];
export const IconSwords = Se("outline", "swords", "Swords", xv);
export const Sv = [["path", {
  d: "M15 5l0 2",
  key: "svg-0"
}], ["path", {
  d: "M15 11l0 2",
  key: "svg-1"
}], ["path", {
  d: "M15 17l0 2",
  key: "svg-2"
}], ["path", {
  d: "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2",
  key: "svg-3"
}]];
export const IconTicket = Se("outline", "ticket", "Ticket", Sv);
export const Nv = [["path", {
  d: "M4 7l16 0",
  key: "svg-0"
}], ["path", {
  d: "M10 11l0 6",
  key: "svg-1"
}], ["path", {
  d: "M14 11l0 6",
  key: "svg-2"
}], ["path", {
  d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12",
  key: "svg-3"
}], ["path", {
  d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3",
  key: "svg-4"
}]];
export const IconTrash = Se("outline", "trash", "Trash", Nv);
export const Tv = [["path", {
  d: "M8 21l8 0",
  key: "svg-0"
}], ["path", {
  d: "M12 17l0 4",
  key: "svg-1"
}], ["path", {
  d: "M7 4l10 0",
  key: "svg-2"
}], ["path", {
  d: "M17 4v8a5 5 0 0 1 -10 0v-8",
  key: "svg-3"
}], ["path", {
  d: "M3 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
  key: "svg-4"
}], ["path", {
  d: "M17 9a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
  key: "svg-5"
}]];
export const IconTrophy = Se("outline", "trophy", "Trophy", Tv);
export const Cv = [["path", {
  d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0",
  key: "svg-0"
}], ["path", {
  d: "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2",
  key: "svg-1"
}]];
export const IconUser = Se("outline", "user", "User", Cv);
export const Av = [["path", {
  d: "M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
  key: "svg-0"
}], ["path", {
  d: "M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1",
  key: "svg-1"
}], ["path", {
  d: "M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
  key: "svg-2"
}], ["path", {
  d: "M17 10h2a2 2 0 0 1 2 2v1",
  key: "svg-3"
}], ["path", {
  d: "M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
  key: "svg-4"
}], ["path", {
  d: "M3 13v-1a2 2 0 0 1 2 -2h2",
  key: "svg-5"
}]];
export const IconUsersGroup = Se("outline", "users-group", "UsersGroup", Av);
export const Ev = [["path", {
  d: "M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0",
  key: "svg-0"
}], ["path", {
  d: "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2",
  key: "svg-1"
}], ["path", {
  d: "M16 3.13a4 4 0 0 1 0 7.75",
  key: "svg-2"
}], ["path", {
  d: "M21 21v-2a4 4 0 0 0 -3 -3.85",
  key: "svg-3"
}]];
export const IconUsers = Se("outline", "users", "Users", Ev);
export const Dv = [["path", {
  d: "M18 6l-12 12",
  key: "svg-0"
}], ["path", {
  d: "M6 6l12 12",
  key: "svg-1"
}]];
export const IconX = Se("outline", "x", "X", Dv);
export const zv = [["path", {
  d: "M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z",
  key: "svg-0"
}]];
